import request from '@/utils/request'

// 获取首页主题分类
export function getHomeTopicList(query: object) {
  return request({
    url: '/largePage/listPage',
    method: 'get',
    params: query
  })
}

// 获取首页功能导航
export function getHomeNavList(query: object) {
  return request({
    url: '/largePage/listNavigation',
    method: 'get',
    params: query
  })
}

// 获取窗口电话
export function getWindowPhone(query: object) {
  return request({
    url: '/largePage/listPgone',
    method: 'get',
    params: query
  })
}

// 获取首页前五条数据
export function getPrevFiveList(query: object) {
  return request({
    url: '/largePage/listPageFive',
    method: 'get',
    params: query
  })
}

// 获取首页站点信息
export function getHomeSiteData(query: object) {
  return request({
    url: '/largePage/listSiteMessage',
    method: 'get',
    params: query
  })
}

// 登录
export function getLoginData(query: object) {
  return request({
    url: '/system/login/lohginMessage',
    method: 'get',
    params: query
  })
}

// 获取用户信息
export function getUserInfoData(query: object) {
  return request({
    url: '/system/login/selectMessage',
    method: 'get',
    params: query
  })
}

// 获取我的反馈列表
export function getMyFeedbackList(query: object) {
  return request({
    url: '/largePage/getFk',
    method: 'get',
    params: query
  })
}

// 修改我的设置
export function updateMySetting(data: object) {
  return request({
    url: '/system/login/updateMessage',
    method: 'post',
    data
  })
}

// 修改我的设置
export function getHomeSearchList(query: object) {
  return request({
    url: '/largePage/listDim',
    method: 'get',
    params: query
  })
}

// 统计调用接口
export function staticAllData(query: object) {
  return request({
    url: '/largePage/addH5Count',
    method: 'get',
    params: query
  })
}

// 收藏
export function getCollectYes(data: object) {
  return request({
    url: '/largePage/addCollect',
    method: 'post',
    data
  })
}

// 取消收藏
export function getCollectNo(data: object) {
  return request({
    url: '/largePage/deleteCollect',
    method: 'post',
    data
  })
}

// 获取我的收藏列表
export function getCollectList(query: object) {
  return request({
    url: '/largePage/listCollect',
    method: 'get',
    params: query
  })
}

// 获取签名
export function getSignature(query: object) {
  return request({
    url: '/system/login/lohginMessageTicket',
    method: 'get',
    params: query
  })
}
